
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projekte/[postID]",
      function () {
        return require("private-next-pages/projekte/[postID].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projekte/[postID]"])
      });
    }
  